<template>
  <div>
    <detail-template :id='1'></detail-template>
  </div>
</template>

<script>
import detailTemplate from '../detail-template.vue';
export default {
  metaInfo: {
    title: '马兰头医学科技｜微医（挂号网）',
    meta: [
      {
        name: 'keywords',
        content: '马兰头医学科技，实时音视频，微医'
      },
      {
        name: 'description',
        content: '马兰头医学科技和微医就实时音视频达成合作'
      },
    ]
  },
  components: {
    detailTemplate,
  },
}
</script>

<style lang="less" scoped>

</style>